import _ from 'lodash'
import { z } from 'zod'

import { WorkspaceAmazonSlice } from '../../hooks/useGetWorkspaceAmazon'

const pubId = z.string().length(36)

export const schema = z.object({
  enabled: z.boolean(),
  id: z.string().optional(),
  pubId,
})
export type Schema = z.infer<typeof schema>

export const schemaDefault = (workspaceAmazon: null | undefined | WorkspaceAmazonSlice): Schema => {
  if (_.isNil(workspaceAmazon)) {
    return {
      enabled: false,
      pubId: '',
    }
  }

  const { enabled, id, pubId } = workspaceAmazon

  return {
    enabled,
    id,
    pubId: pubId ?? '',
  }
}
